import { defaultValues as addressDefaultValues } from "@/components/form-fields/AddressForm/utils/defaultValues";
import { GasStepsFormDataMap } from "../types/stepsFormData";

export const installationStep: GasStepsFormDataMap["installation"] = {
  cups: '',
  cupsSIPSData: undefined,
  address: addressDefaultValues,
  // TODO: Add Settings.contractation?.defaultCnaeCheck
  residenceType: "habitual",
  cnae: {
    id: 986,
    name: "9820",
    descripcio: "9820: Actividades de los hogares como productores de servicios para uso propio"
  },
  invoice: [],
  comerOrigin: '',
  activeContract: null,
  acceptMorosityVerification: false,
  leadsConsent: false,
}

export const personStep: GasStepsFormDataMap["person"] = {
  vat: '',
  company: false,
  name: '',
  surName1: '',
  surName2: '',
  cif: '',
  changeOwner: null,
  vatRepresentante: '',
  nameRepresentante: '',
  surName1Representante: '',
  surName2Representante: '',
  sameInvoiceAddress: true,
  ownerAddress: {
    dp: '',
    ine: '',
    nv: '',
    pnp: '',
    poblacio: '',
    state: '',
    tv: '',
    aclarador: '',
    bq: '',
    es: '',
    pt: '',
    pu: '',
    ref_catastral: '',
  },
  commsLanguage: '',
  email: '',
  mobile: '',
  nifFaceup: [],
  nifEmpresa: [],
  vatTokenized: false,
  activeContract: null,
}

export const contractStep: GasStepsFormDataMap["gasContract"] =  {
  accessTariff: {
    id: -1,
    name: ""
  },
  selectedProduct: -1
}

export const paymentStep: GasStepsFormDataMap["payment"] = {
  iban: '',
  isOwner: false,
}

export const confirmationStep: GasStepsFormDataMap["confirmation"] = {
  acceptOVConditions: false,
  acceptGdpr: false,
  acceptPublicity: false,
  ip: ""
}

const base = {
  
  submitting: false,
  leadId: null,
  gasLeadId: null,
  leadsConsent: false,
  leadErrors: {
    badScore: false,
    dniInvalid: false,
    genericError: false
  },

  latestStep: 0,
  completedSteps: {},
  currentStep: {
    index: 0,
    name : "installation"
  },

  config: {
    name: '',
    surName1: '',
    surName2: '',
    mobile: '',
    vat: '',
    email: '',
    isFetching: true
  },

  steps: {
    installation: installationStep,
    person: personStep,
    gasContract: contractStep,
    payment: paymentStep,
    confirmation: confirmationStep,
    finish: undefined
  } satisfies GasStepsFormDataMap,

  availableProducts: [],
  selectedProduct: null,
  selectedProductName: null,
} as const;

export default base;
